import { Box, Button, TextField } from "@mui/material";
import {
    Form,
    useLoaderData
} from "react-router-dom";
import { Result } from "../../types/Result";
import MuAutocomplete from "../components/autocomplete/MuiAutocomplete";
import { Hospital } from "./type";

export default function HospitalForm() {
    const data = useLoaderData() as Result<Hospital>;
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '800px' } }}>
            <Form method="post">
                <TextField
                    placeholder="Id"
                    type="text"
                    name="id"
                    value={data.data?.id}
                    fullWidth
                    margin="dense"
                    label="Id"
                    disabled
                />
                <TextField
                    placeholder="Ad"
                    type="text"
                    name="hospitalName"
                    defaultValue={data.data?.hospitalName}
                    fullWidth
                    margin="dense"
                    label="Ad"
                    required
                />
                <MuAutocomplete margin="dense" fullWidth url="/api/cities" dataItemKey="cityCode" name="cityCode" dataTextValue="cityName" label="Şehir" defaultValue={data.data?.cityCode} />
                <Button fullWidth type="submit" variant="contained">Kaydet</Button>
            </Form>
        </Box>
    );
}